import { Group, Pill } from "@mantine/core";
import { DateFilter } from "../../../contexts/OrderListFilterContext";

interface Props {
  name: string;
  value?: DateFilter;
}

const DateRangeFilter = ({ name, value }: Props) => {
  if (value == null) return null;

  return (
    <Group gap="0">
      {value?.start && (
        <>
          <Pill>{name}</Pill>
          <Pill>{">="}</Pill>
          <Pill>{value.start.toLocaleDateString()}</Pill>
        </>
      )}
      {value?.end && (
        <>
          <Pill>{name}</Pill>
          <Pill>{"<="}</Pill>
          <Pill>{value.end.toLocaleDateString()}</Pill>
        </>
      )}
    </Group>
  );
};

export default DateRangeFilter;
